/**
 * Deli cheeses data
 * Represents cheeses available by weight at the deli counter
 */

const deliCheeses = [
  {
    id: 1,
    name: "Domestic Swiss",
    category: "cheeses"
  },
  {
    id: 2,
    name: "Baby Swiss",
    category: "cheeses"
  },
  {
    id: 3,
    name: "Jarlsberg Swiss",
    category: "cheeses"
  },
  {
    id: 4,
    name: "Muenster",
    category: "cheeses"
  },
  {
    id: 5,
    name: "Yellow American",
    category: "cheeses"
  },
  {
    id: 6,
    name: "Sharp Cheddar",
    category: "cheeses"
  },
  {
    id: 7,
    name: "Pepper Jack",
    category: "cheeses"
  },
  {
    id: 8,
    name: "Provolone",
    category: "cheeses"
  },
  {
    id: 9,
    name: "Havarti",
    category: "cheeses"
  }
];

module.exports = deliCheeses;
